import React from 'react';

interface Props {
  children: React.ReactNode;
  title?: string;
}

interface State {
  error: Error | null;
}

// Bắt lỗi render của cây con — không cho crash cả app và HIỆN nội dung lỗi ra màn hình.
export class ErrorBoundary extends React.Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo): void {
    // eslint-disable-next-line no-console
    console.error('[ErrorBoundary]', error, info);
  }

  render(): React.ReactNode {
    const { error } = this.state;
    if (error) {
      return (
        <div style={{ padding: 12, maxWidth: 360, color: '#ba1a1a', fontSize: 12 }}>
          <strong>{this.props.title || 'Đã xảy ra lỗi'}</strong>
          <pre style={{ whiteSpace: 'pre-wrap', margin: '6px 0 0', fontSize: 11, lineHeight: 1.4 }}>
            {error.message}
          </pre>
        </div>
      );
    }
    return this.props.children;
  }
}
